import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Some browser bundles still reference `process` (e.g. Node-oriented deps).
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = { env: { NODE_ENV: process.env.NODE_ENV } };
}

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
